import {HamrahAvalIcon, HovitaIcon, ParsSignIcon, TejaratTosehIcon} from "./icons/FooterIcons";

export default function Footer() {

    return(
        <div className={`border-footer my-3 mx-2 mx-md-auto text-center`}>

            <div className='row justify-content-center pt-2 mb-1' >
                <div className={`col-12 col-md-6 pe-0 pe-md-3 ps-0 row justify-content-center pb-2`} style={{borderBottom: "1px solid #d3d3d3"}}>
                    <div className={`col-3 p-0`}>
                        <TejaratTosehIcon />
                    </div>
                    <div className={`col-3 p-0`}>
                        <HamrahAvalIcon />
                    </div>
                    <div className={`col-3 p-0`}>
                        <ParsSignIcon />
                    </div>
                    <div className={`col-3 p-0`}>
                        <HovitaIcon />
                    </div>
                </div>

            </div>

            <div className='row justify-content-center pt-2 mb-2'
                 style={{"fontWeight" : "700", "fontSize" : "0.7rem", width: "100%"}}
            >
                <div className={`col-3 me-md-3`} style={{maxWidth: "100px"}}>
                    <a
                        style={{color: "black", textDecoration: "none"}}
                        href={'https://blog.gavahit.com/'}
                        target={'_blank'}
                    >بلاگ گواهیت</a>
                </div>
                <div className={`col-3 p-0 mx-md-2`} style={{maxWidth: "100px"}}>
                    <a
                        style={{color: "black", textDecoration: "none"}}
                        href={'https://blog.gavahit.com/help'}
                        target={'_blank'}
                    >راهنمای سامانه</a>
                </div>
                <div className={`col-3 me-md-2`} style={{maxWidth: "100px"}}>
                    <a
                        style={{color: "black", textDecoration: "none"}}
                        href={'https://blog.gavahit.com/contact'}
                        target={'_blank'}
                    >تماس با ما</a>
                </div>
                <div className={`col-3 p-0 me-md-3`} style={{maxWidth: "100px"}}>
                    <a
                        style={{color: "black", textDecoration: "none"}}
                        href={'https://blog.gavahit.com/about'}
                        target={'_blank'}
                    >درباره گواهیت</a>
                </div>
            </div>

            <div className='row justify-content-center footer-text'>
                <div className="col-12 text-center p-0 col-md-4 mb-2">
                    تمامی حقوق توسط شرکت محفوظ می<span>&#8202;</span>باشد.
                </div>
                <div className="col-12 p-0 text-center col-md-2">
                    پشتیبانی :  ۹۱۰۱۴۶۴۸ - ۰۲۱
                </div>
            </div>
        </div>

    )
}